export default "__VITE_ASSET__B3YnJ_Ge__"